export default class LookupExistsException extends Error {}
